import * as THREE from 'three';
import { mulberry32 } from '../../utils/random';

export class BackgroundTrees {
  public root: THREE.Group;

  constructor() {
    this.root = new THREE.Group();
    const rng = mulberry32(42);
    const trunkMat = new THREE.MeshStandardMaterial({ color: 0x2a1a0a, roughness: 0.9 });
    const foliageMat = new THREE.MeshStandardMaterial({ color: 0x1a3a1a, roughness: 0.8 });
    const foliageMat2 = new THREE.MeshStandardMaterial({ color: 0x2a4a2a, roughness: 0.85 });

    for (let i = 0; i < 26; i++) {
      const angle = (i / 26) * Math.PI * 2 + (rng() - 0.5) * 0.3;
      const radius = 18 + rng() * 12;
      const x = Math.cos(angle) * radius;
      const z = Math.sin(angle) * radius;
      const tree = this.makeTree(trunkMat, rng() > 0.5 ? foliageMat : foliageMat2, rng);
      tree.position.set(x, 0, z);
      tree.scale.setScalar(0.9 + rng() * 0.6);
      this.root.add(tree);
    }

    const fogPlaneGeo = new THREE.PlaneGeometry(120, 30);
    const fogPlaneMat = new THREE.MeshBasicMaterial({
      color: 0x3a5a2a,
      transparent: true,
      opacity: 0.35,
      side: THREE.DoubleSide,
    });
    const fogPlane = new THREE.Mesh(fogPlaneGeo, fogPlaneMat);
    fogPlane.position.set(0, 6, -28);
    this.root.add(fogPlane);
  }

  private makeTree(
    trunkMat: THREE.Material,
    foliageMat: THREE.Material,
    rng: () => number
  ): THREE.Group {
    const tree = new THREE.Group();
    const trunkGeo = new THREE.CylinderGeometry(0.18, 0.28, 4 + rng() * 2, 6);
    const trunk = new THREE.Mesh(trunkGeo, trunkMat);
    trunk.position.y = 2;
    tree.add(trunk);

    for (let i = 0; i < 3; i++) {
      const radius = 1.2 + rng() * 0.8;
      const foliageGeo = new THREE.SphereGeometry(radius, 8, 6);
      const foliage = new THREE.Mesh(foliageGeo, foliageMat);
      foliage.position.set(
        (rng() - 0.5) * 0.6,
        3.5 + i * 0.8,
        (rng() - 0.5) * 0.6
      );
      tree.add(foliage);
    }
    return tree;
  }
}
